/**
 * Agrupación del equipo por departamento — para la entrada (Home) y el mostrador
 * del rail (rediseño Home v2). Data-driven (R-PT-02): el orden de los
 * departamentos es el de PRIMERA APARICIÓN en `agents_visibles`, así el
 * descriptor manda (DKtec lo codifica Dirección→Control; Koana trae los suyos).
 * Dentro de cada departamento la orquestadora va primero (rol ~ /orquest/) y el
 * resto conserva el orden del descriptor. Un agente sin `departamento` cae en un
 * grupo de reserva para no perderse.
 */

const FALLBACK_DEPT = 'Equipo'

function esOrquestadora(a) {
  return /orquest/i.test(a?.rol ?? '')
}

// Estable: orquestadora(s) primero, resto en su orden original.
function orquestadoraPrimero(list) {
  const orq = list.filter(esOrquestadora)
  const resto = list.filter(a => !esOrquestadora(a))
  return [...orq, ...resto]
}

// Devuelve [{ departamento, agents }] preservando el orden de aparición.
export function groupByDepartment(agents = []) {
  const order = []
  const byDept = new Map()
  for (const a of agents) {
    const dept = String(a?.departamento ?? '').trim() || FALLBACK_DEPT
    if (!byDept.has(dept)) {
      byDept.set(dept, [])
      order.push(dept)
    }
    byDept.get(dept).push(a)
  }
  return order.map(departamento => ({
    departamento,
    agents: orquestadoraPrimero(byDept.get(departamento)),
  }))
}
